import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelector = ({ currentRole, locked = true }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="Briefcase" size={20} color="var(--color-accent)" strokeWidth={2} />
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Current Role</p>
          <p className="text-sm font-semibold text-foreground">{currentRole}</p>
        </div>
      </div>
      {locked && (
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Lock" size={14} color="var(--color-muted-foreground)" />
          <span>Locked</span>
        </div>
      )}
    </div>
  );
};

export default RoleSelector;